// 기본 경로 상수
export const VALID_PATHS = [
  '/',
  '/artist',
  '/artist/',
  '/press',
  '/press/',
  '/company',
  '/company/',
  '/contact',
  '/contact/'
];

// 동적 라우트 패턴 상수
export const VALID_PATTERNS = [
  /^\/artist\/[\w-]+$/,          // /artist/:id
  /^\/press\/page\/\d+$/,        // /press/page/:page
  /^\/press\/detail\/[\w-]+$/    // /press/detail/:id
];